/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Col_AspectInputs */

const en_mk_cmp_col_aspect = /** @type {(inputs: Mk_Cmp_Col_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspect`)
};

const id_mk_cmp_col_aspect = /** @type {(inputs: Mk_Cmp_Col_AspectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aspek`)
};

/**
* | output |
* | --- |
* | "Aspect" |
*
* @param {Mk_Cmp_Col_AspectInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_col_aspect = /** @type {((inputs?: Mk_Cmp_Col_AspectInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Col_AspectInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_col_aspect(inputs)
	return en_mk_cmp_col_aspect(inputs)
});